import { computed, signal } from '@angular/core';
import { DriveItemDetails } from '@common/models/drive.model';
import { MimeCategory } from '../enums/mime-type.enum';

export interface TeamItem {
  Id: string;
  Name: string;
  ItemType: TeamItemType;
  MimeCategory: MimeCategory;
}

export enum TeamItemType {
  Team = 'Team',
  Channel = 'Channel',
  FilesRoot = 'FilesRoot',
  PostsRoot = 'PostsRoot',
  File = 'File',
  Folder = 'Folder',
  Root = 'Root' // only for manual create root node
}

export interface ChannelItem extends TeamItem {
  ChannelId: string;
}

export interface TeamOdataPost {
  Id: number;
  FromName: string;
  CreatedDate: string;
  // html content
  Content: string;
  ExistReplies: boolean;
}

export class TeamPost {
  public readonly id: number;
  public readonly userName: string;
  public readonly date: Date;
  public readonly content: string;
  public readonly hasReplies: boolean;

  public readonly showReplies = signal<boolean>(false);
  public readonly replies = signal<TeamPost[]>([]);
  public readonly repliesLoading = signal<boolean>(false);

  public readonly repliesSet = computed<boolean>(() => this.replies()?.length > 0);

  constructor(post: TeamOdataPost) {
    this.id = post.Id;
    this.userName = post.FromName;
    this.date = new Date(post.CreatedDate);
    this.content = post.Content;
    this.hasReplies = post.ExistReplies;
  }
}

export interface TeamFile extends TeamItem {
  ChannelId: number;
  DbId: string;
  Size: number;
  Type: TeamFileItemType;
}

export enum TeamFileItemType {
  Folder,
  File
}

export type ItemTeamItemDetails = { drive: TeamFile; details: DriveItemDetails };
